import { render, staticRenderFns } from "./ToolbarNavigationItem.vue?vue&type=template&id=3192df5e&scoped=true&"
import script from "./ToolbarNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./ToolbarNavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./ToolbarNavigationItem.vue?vue&type=style&index=0&id=3192df5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192df5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
